import api from "../axios_service.js";

export async function fetchEmpresa(user_id) {
  const response = await api.get(`/cliente/empresa?user_id=${user_id}`);
  return response.data.result;
}
